import _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoutePermissionService {
    public list = [{
        path: /^\/dashboard$/,
        access: [1,2,3,4]
    },
    {
        path: /^\/account$/,
        access: [1,2,3,4]
    },
    {
        path: /^\/campaign\/list$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/select-type$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/donation$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/donation\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/merchandise$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/merchandise\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/hindu-temple-puja$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/hindu-temple-puja\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/auction$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/auction\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/party-signup$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/party-signup\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/ticketing$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/ticketing\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/long-pledge$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/long-pledge\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/peer-to-peer-fundraising$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/peer-to-peer-fundraising\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/last-hero$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/last-hero\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/in-kind$/,
        access: [1,2]
    },
    {
        path: /^\/campaign\/in-kind\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/event\/list$/,
        access: [1,3]
    },
    {
        path: /^\/event\/select-type$/,
        access: [1,3]
    },
    {
        path: /^\/event\/in-person$/,
        access: [1,3]
    },
    {
        path: /^\/event\/in-person\/\w+$/,
        access: [1,3]
    },
    {
        path: /^\/event\/in-person\/\w+\/report$/,
        access: [1,3]
    },
    {
        path: /^\/event\/virtual$/,
        access: [1,3]
    },
    {
        path: /^\/event\/virtual\/\w+$/,
        access: [1,3]
    },
    {
        path: /^\/event\/virtual\/\w+\/run$/,
        access: [1,3]
    },
    {
        path: /^\/event\/virtual\/\w+\/report$/,
        access: [1,3]
    },
    {
        path: /^\/event\/hybrid$/,
        access: [1,3]
    },
    {
        path: /^\/event\/hybrid\/\w+$/,
        access: [1,3]
    },
    {
        path: /^\/manage\/tickets-and-guests/,
        access: [1,2]
    },
    {
        path: /^\/manage\/tickets-and-guests\/list/,
        access: [1,2]
    },
    {
        path: /^\/manage\/tickets-and-guests\/campaign\/\w+\/table\/\w+\/seat\/list/,
        access: [1,2]
    },
    {
        path: /^\/manage\/tickets-and-guests\/campaign\/\w+/,
        access: [1,2]
    },
    {
        path: /^^\/manage\/tickets-and-guests\/ticket\/\w+\/guest\/list/,
        access: [1,2]
    },
    {
        path: /^^\/manage\/tickets-and-guests\/ticket\/\w+\/basket-raffle\/allocation\/list/,
        access: [1,2]
    },
    {
        path: /^\/manage\/merchandise/,
        access: [1,2]
    },
    {
        path: /^\/manage\/party-signup/,
        access: [1,2]
    },
    {
        path: /^\/manageAuction$/,
        access: [1,2]
    },
    {
        path: /^\/manageAuction\/list$/,
        access: [1,2]
    },
    {
        path: /^\/manageAuction\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/manage\/p2p\/list$/,
        access: [1,2]
    },
    {
        path: /^\/manage\/p2p\/\w+$/,
        access: [1,2]
    },
    {
        path: /^\/streaming$/,
        access: [1,3]
    },
    {
        path: /^\/integration\/web-hook\/list$/,
        access: [1]
    },
    {
        path: /^\/reportTransfers$/,
        access: [1,4]
    },
    {
        path: /^\/reportAll$/,
        access: [1,2,4]
    },
    {
        path: /^\/reportPendingCarts$/,
        access: [1,3,4]
    },
    {
        path: /^\/reports\/campaign$/,
        access: [1,2,4]
    },
    {
        path: /^\/reports\/campaign\/list$/,
        access: [1,2,4]
    },
    {
        path: /^\/reports\/campaign\/paid\/\w+\/\w+$/,
        access: [1,2,4]
    },
    {
        path: /^\/reports\/campaign\/pending\/\w+\/\w+$/,
        access: [1,2,4]
    },
    {
        path: /^\/reportDonors$/,
        access: [1,4]
    },
    {
        path: /^\/reportRecurring$/,
        access: [1,4]
    },
    {
        path: /^\/reportUnsettled$/,
        access: [1,4]
    },
    {
        path: /^\/reportMatching$/,
        access: [1,4]
    },
    {
        path: /^\/volunteers$/,
        access: [1,2,3,4]
    },
    {
        path: /^\/users$/,
        access: [1,2,3,4]
    },
    {
        path: /^\/offlineOne$/,
        access: [1,2]
    },
    {
        path: /^\/offlineBulk$/,
        access: [1,2]
    },
    {
        path: /^\/legal$/,
        access: [1,2,3,4]
    }]

    constructor() {}

    findRoute(url) {
        for(let route of this.list) {
            const result = route.path.test(url);
            if(result) {
                return route;
            }
        }
        return null
    }
}
